import { type JiraErrorResponse } from './jira-client-types.ts';

export const isError = (response: any): response is JiraErrorResponse =>
  typeof response === 'object' &&
  ('error' in response || 'errors' in response || 'errorMessages' in response);
